module.exports = __webpack_public_path__ + "img/heart-with-yellow-bg.bb02de0e.png";